export default __webpack_public_path__ + "static/media/maggiLogo.b36b83e7.png";